<header class="header" [ngClass]="{ 'logged-in': (authService.isAuthenticated$ | async) === true }">
  <div class="header__left">
    <div class="header__logo" (click)="goHome()">
      <img [src]="logoPath" [alt]="logoAlt" />
    </div>
  </div>

  <!-- Guest view -->
  <div class="header__menu" *ngIf="(authService.isAuthenticated$ | async) === false">
    <div class="header__contact contact-us-btn">
      <button class="button button--contact-us" (click)="goToContactUs()">
        <img src="../../../assets/icons/headphones.svg" alt="Contact Icon" class="contact-icon" />
        <span class="contact-text">Contact us</span>
      </button>
    </div>
    <app-button *ngIf="!isOnMigrationPage" class="login-btn" variant="main" size="md" [isLoading]="isLoggingIn" [disabled]="isLoggingIn" (click)="logIn()">LOG IN</app-button>
    <app-button *ngIf="!isMembershipFlowActive && !isVanityHost" variant="main" size="md" (click)="signUp()">BECOME A MEMBER</app-button>
    <app-button *ngIf="isSchoolSignupEnabled" variant="secondary" size="sm" (click)="createSchoolAccount()">CREATE A SCHOOL ACCOUNT</app-button>
  </div>

  <!-- Authenticated view -->
  <div class="header__user" *ngIf="(authService.isAuthenticated$ | async) === true">
    <app-admin-learner-toggle *ngIf="isGroupAdmin$ | async"></app-admin-learner-toggle>

    <div class="header__contact contact-us-btn">
      <button class="button button--contact-us" (click)="goToContactUs()">
        <img src="../../../assets/icons/headphones.svg" alt="Contact Icon" class="contact-icon" />
        <span class="contact-text">Contact us</span>
      </button>
    </div>

    <button class="button button--logout" (click)="logout()">
      <span class="logout-btn__text">LOGOUT</span>
      <img src="../../../assets/icons/logout.svg" alt="Logout Icon" class="header__logout-icon" />
    </button>

    <!-- Mobile hamburger toggle -->
    <button class="header__icon-button" (click)="toggleDrawer()">
      <img
        [src]="isDrawerOpen ? '../../../assets/icons/close-menu.svg' : '../../../assets/icons/hamburger.svg'"
        alt="Toggle Menu"
        class="header__icon"
      />
    </button>
  </div>
</header>

@if (isDrawerOpen) {
  <app-mobile-drawer (close)="isDrawerOpen = false"></app-mobile-drawer>
}